import UtilServices from "@services/UtilServices";
import "./InputPesquisa.scss";
import "./InputPesquisaMobile.scss";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import { useEffect, useRef, useState } from "react";
import MessageServices from "@services/MessageServices";
import Loading from "@components/loading/Loading";

export default function InputPesquisa({
  id = "",
  changeId = false,
  type = "text",
  placeholder1 = "Field",
  placeholder2 = "Preencha o Field",
  disabled = false,
  title = "",
  onChange = () => null,
  className = "",
  theme = "1",
  style = {},
  marginOnTop = false,
  mask = "",
  maxLength = null,
  defaultValue = "",
  icon = "",
  //ToolTip
  tooltip = false,
  tooltipId = "",
  tooltipIcon = <i className="fa-solid fa-hexagon-exclamation"></i>,
  tooltipDescricao = "",
  tooltipIconColor = "#ff7575c9",
  //Listas
  handleFunctionKey = () => null,
  handleFunctionPesquisa = () => null,
  listKey = [],
  listValue = [],
  //Retorno
  setRetorno = () => null,
  //Clear
  clear = "",
  setClear = () => null,
  //loading
  loading1 = false, //loadingkey
  loading2 = false, //loadingvalue
  //list
  addLstStorage = [],
  namestorage = "",
}) {
  //state
  //list1
  const [openLst1, setOpenLst1] = useState(false);
  const [valueKey, setValueKey] = useState("");
  const [valueKeyChange, setValueKeyChange] = useState("");
  const [listKeyFilter, setListKeyFilter] = useState("");

  //list2
  const [openLst2, setOpenLst2] = useState(false);
  const [value, setValue] = useState("");
  const [listValueFilter, setListValueFilter] = useState("");

  //AddLst
  const [addLst, setAddLst] = useState([]);

  //Teclas
  const [highlightIndex1, setHighlightIndex1] = useState(-1);
  const [highlightIndex2, setHighlightIndex2] = useState(-1);

  //Focus
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);

  useEffect(() => {
    //Retorna do storage
    if (JSON.stringify(addLstStorage) !== JSON.stringify(addLst)) {
      setAddLst(addLstStorage);
    }
  }, [addLstStorage]);

  useEffect(() => {
    //Retorna da aplicação
    setRetorno(addLst);
  }, [addLst]);

  useEffect(() => {
    //Limpar Input
    setAddLst([]);
    setClear(false);
  }, [clear]);

  //className
  let inputClassName1 = `input lst1 ${className} theme${theme}  
  ${disabled ? "disabled" : ""}`;

  let inputClassName2 = `input lst2 ${className} theme${theme}  
  ${valueKey ? "" : "disabled"}`;

  const onReturn = (value) => {
    setListValueFilter(UtilServices.searchLst(value, listValue));
    return setValue({ id: 0, valor: value });
  };

  const handleMask = (e) => {
    //Mascaras
    if (valueKey?.mask === "telefone") {
      e = UtilServices.maskPhone(e);
    } else if (valueKey?.mask === "CPF") {
      e = UtilServices.maskCPF(e);
    } else if (valueKey?.mask === "CNPJ") {
      e = UtilServices.maskCNPJ(e);
    } else if (valueKey?.mask === "Date") {
      e = UtilServices.maskDate(e);
    } else if (valueKey?.mask === "CCM") {
      e = UtilServices.maskCCM(e);
    } else if (valueKey?.mask === "Valores") {
      e = UtilServices.maskCurrency(e);
    } else if (valueKey?.mask === "CNAE") {
      e = UtilServices.maskCNAE(e);
    } else if (valueKey?.mask === "CEP") {
      e = UtilServices.maskCEP(e);
    } else if (valueKey?.mask === "Porcentagem") {
      e = UtilServices.maskPercentage(e);
    } else if (valueKey?.mask === "mesAno") {
      e = UtilServices.maskMonthYear(e);
    } else if (valueKey?.mask === "RG") {
      e = UtilServices.maskRG(e);
    }

    return e;
  };

  const handleChange = (e) => {
    let input = e.target.value;

    if (type === "number") {
      // Remove todos os caracteres que nao sao numeros
      input = input?.replace(/[^0-9]/g, "");
    }
    if (type === "phone") {
      // Remove todos os caracteres que nao sao numeros
      input = input?.replace(/[^0-9+]/g, "");
    }
    if (type === "document") {
      // Remove todos os caracteres que sao numeros
      input = input?.replace(/[0-9]/g, "");
    }
    if (type === "login") {
      // Remove todos os caracteres e espaços
      input = input?.replace(/[^a-zA-Z0-9]/g, "");
    }
    if (type === "password") {
      // Remove todos os espaços
      input = input?.replace(/\s+/g, "");
    }
    if (type === "nomesobrenome") {
      // Remove todos os numeros e caracteres especiais.
      input = input?.replace(/[^A-Za-zÀ-Öà-öçÇıİĞğÜüŞş\s]/g, "");
    }
    if (type === "cpfemail") {
      // Remove apenas espaços
      input = input?.replace(/\s+/g, "");
    }

    return onReturn(handleMask(input));
  };

  const handleAdicionar = (dados) => {
    setValue(dados);
    setOpenLst2(false);
    //Add
    setAddLst((prev) => {
      const valor = { ...dados };
      const exists = prev.some(
        (item) =>
          item.key === valueKey &&
          JSON.stringify(item.valor) === JSON.stringify(valor),
      );
      if (exists) {
        MessageServices.ShowWarning("Item ja foi inserido!");
        setValue("");
        return prev;
      } else {
        setValue("");
        setValueKey("");
      }
      return [
        ...prev,
        { id: UtilServices.generateUUID(), key: valueKey, valor: { ...dados } },
      ];
    });
  };

  const handleRemover = (id) => {
    const newList = addLst.filter((item) => item.id !== id);
    setAddLst(newList);
    UtilServices.setStorage(namestorage, newList);
  };

  const handleKeyDown = (
    e,
    highlightIndex,
    setHighlightIndex,
    lst,
    setOpen,
    setValue,
    tp = "key",
  ) => {
    //Para o Filed deve apagar tudo.
    if (
      (e.key === "Backspace" && tp === "key") ||
      (e.key === "Delete" && tp === "key")
    ) {
      setValueKey("");
      setValueKeyChange("");
      setHighlightIndex(-1);
      setListKeyFilter(listKey);
    }
    //Para o Filed deve apagar tudo.
    if (e.key === "Backspace" && tp === "valor" && !value) {
      setValueKey("");
      setValueKeyChange("");
      setHighlightIndex(-1);
      setTimeout(() => {
        if (inputRef1.current) {
          const el = inputRef1.current;
          el.focus();
        }
      }, 0);
    }

    if (
      (tp === "valor" && (!openLst2 || !valueKey || openLst1)) ||
      (tp === "key" && !openLst1) ||
      (tp === "key" && lst.length === 0)
    ) {
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault(); // Impede o scroll padrão
      setHighlightIndex((prev) => (prev + 1) % lst.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightIndex((prev) => (prev <= 0 ? lst.length - 1 : prev - 1));
    } else if (e.key === "Enter") {
      //Evento de Enter
      //Caso os 2 forem vazio e o evento for "Enter , ele pesquisa."
      if (!valueKeyChange && tp === "key" && highlightIndex < 0) {
        handleFunctionPesquisa();
        return;
      }
      let selectedItem;
      if (highlightIndex >= 0 && lst[highlightIndex]) {
        selectedItem = lst[highlightIndex];
        setValue(selectedItem);
        setOpen(false);
        setHighlightIndex(-1);
        if (tp === "valor") {
          handleAdicionar(selectedItem);
        }
      }
      //Quando o filtro não existe na lista
      if (highlightIndex < 0 && tp === "valor") {
        if (!value) {
          MessageServices.ShowWarning("Campo não pode ser vazio!");
          return;
        }
        setOpen(false);
        setHighlightIndex(-1);
        handleAdicionar(value);
      }
      //Focar
      if (tp === "valor") {
        //Focar no input 1
        setTimeout(() => {
          if (inputRef1.current) {
            const el = inputRef1.current;
            el.focus();
          }
        }, 0);
      } else if (tp === "key") {
        //Focar no input2
        setTimeout(() => {
          if (inputRef2.current) {
            const el = inputRef2.current;
            el.focus();
          }
        }, 0);

        // consultar os valores
        if (selectedItem && Object.values(selectedItem).length > 0) {
          let dados = {
            tp: "valor",
            id: Object.values(selectedItem)[0],
          };
          handleFunctionKey(dados);
        }
      }
    }
  };

  useEffect(() => {
    if (listKey && Array.isArray(listKey)) {
      setListKeyFilter(listKey);
    }
  }, [listKey?.length]); // menos sensível, mas previne loops

  useEffect(() => {
    // if (listValue && Array.isArray(listValue)) {
    setListValueFilter(listValue);
    // }
  }, [listValue]); // menos sensível, mas previne loops

  /*--SCROOL PARA BAIXO---*/
  const highlightedItemRef1 = useRef(null);
  useEffect(() => {
    if (highlightedItemRef1.current) {
      highlightedItemRef1.current.scrollIntoView({
        behavior: "smooth",
        block: "center", // ou "center" se quiser centralizar
      });
    }
  }, [highlightIndex2]);

  const highlightedItemRef2 = useRef(null);
  useEffect(() => {
    if (highlightedItemRef2.current) {
      highlightedItemRef2.current.scrollIntoView({
        behavior: "smooth",
        block: "center", // ou "center" se quiser centralizar
      });
    }
  }, [highlightIndex2]);

  return (
    <>
      <div className={`input-pesquisa ${className} theme${theme}`}>
        <div style={{ display: "flex" }}>
          {title && <p>{title}</p>}
          {tooltip && (
            <p
              data-tooltip-id={tooltipId}
              data-tooltip-content={tooltipDescricao}
              className="tooltipInput"
              style={{ color: tooltipIconColor, cursor: "pointer" }}
            >
              {tooltipIcon}
            </p>
          )}
        </div>
        <div style={{ display: "flex" }}>
          <div className="input-key">
            <input
              ref={inputRef1}
              className={inputClassName1}
              //Quando entrar em focus ele abre a lista.
              onFocus={() => setOpenLst1(true)}
              onBlur={() => {
                setTimeout(() => {
                  setOpenLst1(false);
                }, 100); // espera o clique terminar antes de fechar
              }}
              placeholder={placeholder1}
              onChange={(e) => {
                setOpenLst1(true);
                setValueKeyChange(e.target.value);
                setListKeyFilter(
                  UtilServices.searchLst(e.target.value, listKey),
                );
              }}
              onKeyDown={(e) => {
                handleKeyDown(
                  e,
                  highlightIndex1,
                  setHighlightIndex1,
                  listKeyFilter,
                  setOpenLst1,
                  setValueKey,
                );
              }}
              value={Object.values(valueKey)[1] || valueKeyChange}
            />
            {openLst1 && !loading1 && (
              <div className="list">
                {listKeyFilter.length > 0 ? (
                  <ul>
                    {listKeyFilter.map((item, index) => (
                      <li
                        ref={
                          index === highlightIndex1 ? highlightedItemRef1 : null
                        }
                        onMouseDown={() => {
                          setValueKey(item);
                          setOpenLst1(false);
                          setHighlightIndex1(-1);

                          //Focar no input 2
                          setTimeout(() => {
                            if (inputRef2.current) {
                              const el = inputRef2.current;
                              el.focus();
                            }
                          }, 0);

                          // consultar os valores
                          let dados = {
                            tp: "valor",
                            id: Object.values(item)[0],
                          };
                          handleFunctionKey(dados);
                        }}
                        className={`${
                          index === highlightIndex1 ? "highlight" : ""
                        } ${
                          Object.values(valueKey)[0] === Object.values(item)[0]
                            ? "active"
                            : ""
                        }`}
                        key={index}
                      >
                        {Object.values(item)[1]}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>sem dados</p>
                )}
              </div>
            )}
            {loading1 ? (
              <div className="loading1">
                <div className="dataGrid-loading">
                  <Loading
                    color="#c1abff"
                    show={loading1}
                    individual={true}
                    size={15}
                  />
                </div>
              </div>
            ) : (
              <div
                onClick={() => {
                  setOpenLst1(!openLst1);
                }}
                className={`icon ${openLst1 ? "open" : ""}`}
              >
                <i class="fa-solid fa-caret-up"></i>
              </div>
            )}
          </div>
          <div className="input-valor">
            {loading2 && (
              <div className="loading1">
                <Loading
                  color="#c1abff"
                  show={loading2}
                  individual={true}
                  size={15}
                />
              </div>
            )}
            <input
              ref={inputRef2}
              id={id}
              disabled={valueKey ? false : true}
              className={inputClassName2}
              type={
                valueKey?.type === "number" ||
                valueKey?.type === "document" ||
                valueKey?.type === "date"
                  ? "text"
                  : valueKey?.type
              }
              onChange={(e) => {
                setOpenLst2(true);
                handleChange(e);
              }}
              onKeyDown={(e) => {
                handleKeyDown(
                  e,
                  highlightIndex2,
                  setHighlightIndex2,
                  listValueFilter,
                  setOpenLst2,
                  setValue,
                  "valor",
                );
              }}
              placeholder={valueKey?.placeholder || placeholder2}
              onFocus={() => {
                setOpenLst2(true);
              }}
              onBlur={() => {
                setTimeout(() => {
                  setOpenLst2(false);
                }, 100);
              }}
              defaultValue={defaultValue}
              value={Object.values(value)[1] || ""}
            />
            {openLst2 && valueKey && !openLst1 && !loading2 && (
              <div className="list">
                {listValueFilter.length > 0 ? (
                  <ul>
                    {listValueFilter.map((item, index) => (
                      <li
                        ref={
                          index === highlightIndex2 ? highlightedItemRef2 : null
                        }
                        onMouseDown={() => {
                          handleAdicionar(item);
                          setHighlightIndex2(-1);

                          //Focar no input 1
                          setTimeout(() => {
                            if (inputRef1.current) {
                              const el = inputRef1.current;
                              el.focus();
                            }
                          }, 0);
                        }}
                        className={`${
                          index === highlightIndex2 ? "highlight" : ""
                        } ${
                          Object.values(value)[0] === Object.values(item)[0]
                            ? "active"
                            : ""
                        }`}
                        key={index}
                      >
                        {Object.values(item)[1]}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>sem dados</p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="lista-adicionada">
        {addLst?.map((item, index) => (
          <div key={index} className="lista-item">
            {`${item?.key?.valor}: ${Object.values(item?.valor)[1]}`}
            <ButtonIcon
              Excluir
              onExcluir={() => {
                handleRemover(item?.id);
              }}
            />
          </div>
        ))}
      </div>
    </>
  );
}

InputPesquisa.defaultProps = {};
